import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import LabeledList from '~/components/LabeledList';

export default function NoModelsFound() {
    return (
        <LabeledList label="Model">
            <Box display="flex" justifyContent="center" width="100%">
                <Typography variant="body2">
                    <FormattedMessage id="noModelsFound" />.
                </Typography>
            </Box>
        </LabeledList>
    );
}
